import { config } from '@uhg-abyss/web/tools/config';
import { getFeature } from '../../tools/features';
import { http } from '../../tools/http';
import { parseOnboarding } from './parsers';

export const getOnboardingRequest = async (payload) => {
  const basePath = `${config('CORE_STARGATE_API_URL')}`;

  const { data } = await http({
    id: 'get-onboarding',
    resource: 'utility',
    method: 'GET',
    withCredentials: true,
    url: `${basePath}/api/tooltips/preference`,
    query: {
      uuid: payload,
    },
    handleSuccess: (res) => {
      res.data = parseOnboarding(res.data);
      return res;
    },
  });

  if (!data || data.serviceCallStatus === 'failure') {
    throw data;
  }

  return data;
};

export const setOnboardingRequest = async (payload) => {
  const basePath = `${config('CORE_STARGATE_API_URL')}`;

  const { data } = await http({
    id: 'set-onboarding',
    resource: 'utility',
    method: 'PUT',
    withCredentials: true,
    cache: {
      clear: ['get-onboarding', 'set-onboarding'],
    },
    url: `${basePath}/api/tooltips/preference`,
    query: {
      uuid: payload.uuid,
    },
    body: {
      displayToolTip: false,
      displayClaimsTooltip: getFeature('CLAIMS_TRAINING_TOOL_TIPS')
        ? payload.tooltips.claims
        : payload.dbValues.claims,
      displayEligibilityTooltip: getFeature('ELIGIBILITY_TRAINING_TOOL_TIPS')
        ? payload.tooltips.eligibility
        : payload.dbValues.eligibility,
      displayTrackitTooltip: getFeature('TRACKIT_TRAINING_TOOL_TIPS')
        ? payload.tooltips.trackit
        : payload.dbValues.trackit,
      displayReferralTooltip: getFeature('REFERRALS_TRAINING_TOOL_TIPS')
        ? payload.tooltips.referrals
        : payload.dbValues.referrals,
      displatyDocLibTooltip: getFeature('DOCVAULT_TRAINING_TOOL_TIPS')
        ? payload.tooltips.documentLibrary
        : payload.dbValues.documentLibrary,
      displayDLTeamsViewTooltip: getFeature('DL_TEAMS_VIEW_TRAINING_TOOL_TIPS')
        ? payload.tooltips.DLTeamsView
        : payload.dbValues.DLTeamsView,
      displayDashboardTooltip: getFeature('DASHBOARD_TRAINING_TOOL_TIPS')
        ? payload.tooltips.dashboard
        : payload.dbValues.dashboard,
      displayDSTooltip: getFeature('DIGISEC_TRAINING_TOOL_TIPS')
        ? payload.tooltips.digisec
        : payload.dbValues.digisec,
      skipTheTour: !payload.intros.tour,
      viewedIntroduction: !payload.intros.tooltips,
      viewedReferralNotification: !payload.intros.referrals,
      viewedTrackitNotification: !payload.intros.trackit,
      viewedDocLibNotification: !payload.intros.documentLibrary,
      viewedDLTeamsViewNotification: !payload.intros.DLTeamsView,
      viewedDashboardNotification: !payload.intros.dashboard,
      viewedDSNotification: !payload.intros.digisec,
    },
  });

  if (!data || data.serviceCallStatus === 'failure') {
    throw data;
  }

  return payload;
};
